var map = {
	"./A-wing.png": 7927,
	"./AA-9 Coruscant freighter.png": 5581,
	"./B-wing.png": 5322,
	"./Banking clan frigte.png": 5627,
	"./Belbullab-22 starfighter.png": 6165,
	"./CR90 corvette.png": 7603,
	"./Calamari Cruiser.png": 5527,
	"./Death Star.png": 5668,
	"./Droid control ship.png": 6052,
	"./EF76 Nebulon-B escort frigate.png": 3799,
	"./Executor.png": 8689,
	"./H-type Nubian yacht.png": 8913,
	"./Imperial shuttle.png": 1397,
	"./J-type diplomatic barge.png": 568,
	"./Jedi Interceptor.png": 6120,
	"./Jedi starfighter.png": 1596,
	"./Millennium Falcon.png": 2626,
	"./Naboo Royal Starship.png": 9920,
	"./Naboo fighter.png": 3266,
	"./Naboo star skiff.png": 3849,
	"./Rebel transport.png": 1832,
	"./Republic Assault ship.png": 9811,
	"./Republic Cruiser.png": 1007,
	"./Republic attack cruiser.png": 3039,
	"./Scimitar.png": 8346,
	"./Sentinel-class landing craft.png": 2383,
	"./Slave 1.png": 5587,
	"./Solar Sailer.png": 311,
	"./Star Destroyer.png": 9777,
	"./TIE Advanced x1.png": 3090,
	"./Theta-class T-2c shuttle.png": 2979,
	"./Trade Federation cruiser.png": 643,
	"./V-wing.png": 2600,
	"./X-wing.png": 645,
	"./Y-wing.png": 5733,
	"./arc-170.png": 1998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8866;